// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DriveTimeToolImports.Feature {
  padding-bottom: 3rem;
}
.DriveTimeToolImports.Feature > .container-fluid {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0 4rem;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/pages/Imports/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AAEJ","sourcesContent":[".DriveTimeToolImports.Feature {\n  padding-bottom: 3rem;\n  > .container-fluid {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding: 0 4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
